export const FD_PROXY = '/proxy/first-data';
export const INTL_LOCAL_DEV_FD_PROXY_URL = '/proxy/th-first-data';

export const INTL_DEV_STAGING_FD_URL = 'https://api-cat.payeezy.com';
